<template>
  <div>
   <v-container>
    <div v-show="isVisibleProp"></div>
    <v-alert
      v-if="isCSCTransaction"
      id="mtgTransItemVerifiedBanner"
      class="mtg-trans-item-verified-banner mb-2"
      dense
      :type="editedItem.isVerified ? 'success' : 'warning'"
      style="cursor: pointer; margin-top: -32px;"
      @click.native="toggleCscVerified"
    >
      {{ editedItem.isVerified ? 'Verified' : 'Reviewed and Verified? Click to confirm' }}
    </v-alert>
    <v-row>
      <v-col cols="2">
        <v-text-field dense id="mtgTransItemFyText"
          class="mtg-trans-item-fy-text"
          label="Fiscal Year"
          v-model.number="editedItem.fiscalYear"
          type="number"
          :rules="fiscalYearValidation"
          :disabled="true"
        ></v-text-field>
      </v-col>
      <v-col col="3">
        <ClarionDateControl id="mtgTransItemBuisnessDate"
          class="mtg-trans-item-business-date"
          :isIsoDate="true"
          label="Business Date"
          dense
          v-model="editedItem.businessDate"
          :rules="[businessDateValidation, ...reqdSelectValidation]"
        />
      </v-col>
      <v-col col="3">
        <GetMaxReceiptNumber id="mtgTransItemMaxReceiptNo"
          class="mtg-trans-item-max-receipt-no"
          dense
          v-model.number="editedItem.receiptNumber"
          :fiscalYear="editedItem.fiscalYear"
          :isNewItem="isNewItem"
          fieldType="Receipt Number"
          :rules="reqdSelectValidation"
        />
      </v-col>
      <v-col cols="4">
        <v-autocomplete dense id="mtgTransItemReceivedOfComplete"
          class="mtg-trans-received-of"
          v-model="editedItem.receivedOf"
          label="Received Of"
          autofocus
          :items="receivedOf"
          v-uppercase=globalSettingItem.conEverythingToCaps
          @keydown="whomShortcutHandler"
          @update:list-index="whomUpdateSearchInputByNumber"
          @update:search-input="whomUpdateSearchInput"
          @focus="roundAmount(); $event.target.select()"
          @blur="autofillMortgagee"
          :disabled="isCorrectionMode"
        ></v-autocomplete>
      </v-col>
    </v-row>
      <v-row>
      <v-col cols="4">
        <v-textarea dense id="mtgTransItemMortgagorText"
          class="mtg-trans-item-mortgagor-text"
          label="Mortgagor"
          v-textAreaUppercase=globalSettingItem.conEverythingToCaps
          v-model="editedItem.mortgagor"
          rows="2"
          :disabled="isCorrectionMode"
        ></v-textarea>
      </v-col>
        <v-col cols="3">
        <v-textarea dense id="mtgTransItemMortgageeText"
          class="mtg-trans-item-mortgagee-text"
          label="Mortgagee"
          rows="2"
          v-textAreaUppercase=globalSettingItem.conEverythingToCaps
          v-model="editedItem.mortgagee"
          @focus="$event.target.select()"
          @blur="checkExemptMortgagee"
          :disabled="isCorrectionMode"
        ></v-textarea>
        </v-col>
        <v-col cols="2">
          <v-checkbox dense id="mtgTransItemExemptCheckbox"
            class="mtg-trans-item-exempt-checkbox"
            v-model="editedItem.isExempt"
            label="Exempt"
            @change="recalculateMortgageTax"
          ></v-checkbox>
        </v-col>
        <v-col cols="3">
        <v-textarea dense id="mtgTransItemPropertyText"
          class="mtg-trans-item-property-text"
          label="Property"
          rows="2"
          v-textAreaUppercase=globalSettingItem.conEverythingToCaps
          v-model="editedItem.property"
          :disabled="isCorrectionMode"
        ></v-textarea>
        </v-col>
      <v-col cols="4">
        <v-text-field dense id="mtgTransItemSectionLotText"
          class="mtg-trans-item-section-lot-text"
          label="Section/Lot"
          v-uppercase=globalSettingItem.conEverythingToCaps
          v-model="editedItem.sectionLot"
          :disabled="isCorrectionMode"
        ></v-text-field>
      </v-col>
      <v-col cols="4">
        <v-text-field dense id="mtgTransItemTownshipText"
          class="mtg-trans-item-township-text"
          label="Township"
          v-uppercase=globalSettingItem.conEverythingToCaps
          v-model="editedItem.township"
          :disabled="isCorrectionMode"
        ></v-text-field>
      </v-col>
      <v-col cols="4">
        <v-text-field dense id="mtgTransItemRangeBlkText"
          class="mtg-trans-item-range-blk-text"
          label="Range/Blk"
          v-uppercase=globalSettingItem.conEverythingToCaps
          v-model="editedItem.rangeBlk"
          :disabled="isCorrectionMode"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="4">
        <ClarionDateControl id="mtgTransItemMortgageDate"
          class="mtg-trans-item-mortgage-date"
          label="Date of Mortgage"
          dense
          v-model="editedItem.dateOfMortgage"
          :isIsoDate="true"
          @blurred="calculateDateDifference"
          :isDisabled="isCorrectionMode"
        />
      </v-col>
      <v-col cols="4">
        <ClarionDateControl id="mtgTransItemMortgageDueDate"
          class="mtg-trans-item-mortgage-due-date"
          label="Mortgage Due"
          dense
          v-model="editedItem.mortgageDueDate"
          :isIsoDate="true"
          @blurred="calculateDateDifference"
          :rules="termYearValidation"
          :isDisabled="isCorrectionMode"
        />
      </v-col>
      <v-col cols="4">
        <v-text-field dense id="mtgTransItemTermYrsText"
          class="mtg-trans-item-term-text"
          label="Term(Yrs)"
          v-model="editedItem.termYear"
          @blur="recalculateROT"
          @keyup="recalculateROT"
          :disabled="isCorrectionMode"
        ></v-text-field>
      </v-col>
    </v-row>
      <v-row>
        <v-col cols="4">
        <v-text-field dense id="mtgTransItemMortgageAmtText"
          class="mtg-trans-item-mortgage-amt-text"
          label="Mortgage Amount"
          v-model="editedItem.mortgageAmount"
          @blur="recalculateMortgageTax(); roundAmount()"
          @keyup="recalculateMortgageTax"
          :disabled="isCorrectionMode"
        ></v-text-field>
      </v-col>
      <v-col cols="4">
        <v-text-field dense id="mtgTransItemRateOfTaxText"
          class="mtg-trans-item-rate-of-tax-text"
          label="Rate of Tax"
          v-model="editedItem.rateOfTax"
          @blur="recalculateMortgageTax"
          @keyup="recalculateMortgageTax"
          :disabled="isCorrectionMode"
        ></v-text-field>
      </v-col>
      <v-col cols="4">
        <v-text-field dense id="mtgTransItemMortgageTaxText"
          class="mtg-trans-item-mortgage-tax-text"
          label="Mortgage Tax"
          v-model="editedItem.mortgageTax"
          @blur="recalculateAmount"
          @keyup="recalculateAmount"
        ></v-text-field>
      </v-col>
      </v-row>
    <v-row>
      <v-col cols="4">
        <v-text-field dense id="mtgTransItemFeeText"
          class="mtg-trans-item-fee-Text"
          label="Fee"
          v-model="editedItem.fee"
          @blur="recalculateAmount"
          @keyup="recalculateAmount"
        ></v-text-field>
      </v-col>
      <v-col cols="4">
        <v-text-field dense id="mtgTransItemTotalText"
          class="mtg-trans-item-total-Text"
          label="Total"
          v-model="editedItem.amount"
          @focus="amountToNum()"
          readonly
        ></v-text-field>
      </v-col>
      <v-col cols="4">
          <v-text-field dense id="mtgTransItemWkstText"
            class="mtg-trans-item-wkst-Text"
            label="Work Station"
            v-model="editedItem.wkst"
            type="string"
            :disabled="!disableEditWkst || isCorrectionMode"
          ></v-text-field>
        </v-col>
    </v-row>
    <v-row>
      <v-col cols="4">
        <v-textarea dense id="mtgTransItemRemarkText"
          class="mtg-trans-item-remark-Text"
          label="Remarks"
          rows="2"
          v-textAreaUppercase=globalSettingItem.conEverythingToCaps
          v-model="editedItem.remark"
        ></v-textarea>
      </v-col>
        <v-col cols="2">
          <v-checkbox dense id="mtgTransItemVoidCheckbox"
            class="mtg-trans-item-void-checkbox"
            v-model="editedItem.isVoid"
            label="Void"
            :rules="voidAndBatchPaymentValidation"
            @change="isVoidChecked"
            :disabled="isCorrectionMode"
          ></v-checkbox>
        </v-col>
      <v-col cols="3">
        <GetMaxTransNumber id="mtgTransItemTransNoText"
          v-model.number="editedItem.transactionNumber"
          class="mtg-trans-item-trans-no-Text"
          dense
          fieldType="Transaction Number"
          :fiscalYear="editedItem.fiscalYear"
          :cmnBaseCrudKey="baseCrudKey"
          :loadLastTransactionNo="loadLastTransactionNo"
          :rules="reqdSelectValidation"
          :disabled="editedItem.isCorrection"
        />
        </v-col>
      <v-col cols="3 ">
        <v-tooltip bottom max-width="320">
          <template v-slot:activator="{ on, attrs }">
            <!-- The hover listeners go on a plain wrapper, not on the v-checkbox:
                 a real DOM node gets native mouseenter/leave, and the wrapper spans
                 the label text too, which is what users actually aim at. -->
            <div class="d-inline-block" v-bind="attrs" v-on="on">
              <v-checkbox dense id="mtgCorrectionVoidCheckbox"
                class="mtg-correction-item-void-checkbox"
                v-model="editedItem.isCorrection"
                label="Correction"
                @change="isCorrectionChecked"
              ></v-checkbox>
            </div>
          </template>
          <span>{{ correctionHoverCaption }}</span>
        </v-tooltip>
      </v-col>
      <v-col cols="4">
        <v-textarea dense id="mtgTransItemCommentsForInternalUseText"
          class="mtg-trans-item-comment-Text"
          label="Comments (Internal Use Only)"
          rows="2"
          v-textAreaUppercase=globalSettingItem.conEverythingToCaps
          v-model="editedItem.commentsForInternalUse" />
      </v-col>
    </v-row>
    <v-row>
      <v-col v-if="!transactionId">
        <PaymentDetails id="mtgTransItemPaymentDetails"
          class="mtg-trans-item-payment-details"
          v-model="editedItem.paymentDetails"
          toolbarTitle="Payment Details"
          :amount="editedItem.amount"
          :whomString="editedItem.receivedOf"
          :cmnEnums="cmnEnums"
          :defaultForteConfig="defaultForteConfig"
          :isDialogBoxVisible="isVisibleProp"
          :isTotal="true"
          :paymentDetailsFlags="{ isCallForNormalPayment:true }"
          :transactionId="transactionId"
          :showPaymentHeader="true"
          :addDefaultRow="true"
          :isReadOnly="isCorrectionMode"
          :programType="'MTG'"
          :mtgReceiptItem="editedItem"
          @forteResponse="mtgForteResponse"
          @totalRemainingPaymentAmount="totalRemainingPaymentAmount"
          @payrixSuccess="$emit('payrixSuccess')"
        />
      </v-col>
    </v-row>
    <v-row
      v-if="transactionId"
    >
      <v-col>
        <PaymentDetails id="mtgTransItemPaymentDetails"
          class="mtg-trans-item-payment-details"
          toolbarTitle="Batch Payment Details"
          :isReadOnly="true"
          :value="transNumValue"
          :whomString="editedItem.receivedOf"
          :cmnEnums="cmnEnums"
          :isDialogBoxVisible="isVisibleProp"
          :paymentDetailsFlags="{ isCallForBatchPayment:true }"
          :isTotal="false"
          :transactionId="transactionId"
          :programType="'MTG'"
          @emitEditBatchPaymntItem="emitEditBatchPaymntItem"
        />
      </v-col>
    </v-row>
    </v-container>
  </div>
</template>

<script>
import {
  mapGetters,
  mapMutations,
  mapActions,
  mapState,
} from 'vuex';
import {
  isShift,
  amountFormat,
  amountToNumber,
  onFocusAutocomplete,
  checkStringEmptiness,
} from '../../../util/shared/vue-global';

import ClarionDateControl from '../../common/ClarionDateControl.vue';
import PaymentDetails from '../../common/paymentDetails/PaymentDetails.vue';
import GetMaxReceiptNumber from './GetMaxReceiptNumber.vue';
import GetMaxTransNumber from '../../common/transactionNumber/GetMaxTransNumber.vue';
import { mortgageCalculator } from '../../../util/shared/tmc-lib';
import {
  toIsoDate,
  correctionHoverCaption,
  hasEnteredPaymentDetails,
  correctionClearsPaymentDetailsPrompt,
} from '../../../util/shared/tmc-global';
import GlobalToCaps from '../../../util/shared/GlobalToCaps.mixin.vue';
import { isCscMtgTransaction } from './MtgTransactionHelper';

const amountFields = [
  'amount',
  'fee',
  'mortgageTax',
  'mortgageAmount',
];
export default {
  name: 'MtgTaxEditedItem',
  mixins: [GlobalToCaps],
  components: {
    ClarionDateControl,
    PaymentDetails,
    GetMaxReceiptNumber,
    GetMaxTransNumber,
  },
  props: {
    baseCrudKey: {
      type: String,
      default: 'mtgTranspayment-dialog',
    },
    attachmentConstants: {
      type: Object,
      default: () => {},
    },
    cmnEnums: {
      type: Object,
      default: () => {},
    },
  },
  data: () => ({
    correctionHoverCaption,
    totalRemainingPayAmt: null,
    whomLastSearched: undefined,
    forceReloadDetails: true,
    whomListCrudKey: 'mtgWhom',
    defaultForteConfig: {
      configScope: 'mtgConfig',
      isRequiredForte: true,
    },
  }),
  created() {
    this.loadConfig({ requiredScope: 'mtgConfig' });
    document.onkeydown = this.shortcutHandler;
  },
  watch: {
    editedItem: {
      handler(val) {
        this.$emit('editItem', val);
      },
      deep: true,
    },
  },
  computed: {
    ...mapGetters('base/crud', [
      'item',
      'items',
      'index',
      'isVisible',
    ]),
    ...mapState({
      mtgSettingItem: (state) => state.SystemConfig.mtgSettingItem || {},
      globalSettingItem: (state) => state.SystemConfig.globalSettingItem,
      exemptMortgageesArrList: (state) => state.base.crud.items.exemptMortgageesArrList || [],
    }),
    ...mapState({
      nextReceiptNumber: (state) => state.mtg.mtgTransaction.nextReceiptNumber,
      mtgDittoStoreValues: (state) => state.mtg.mtgTransaction.mtgDittoButtonStore || {},
    }),
    ...mapState({
      nextTransNumber: (state) => state.common.cmnTransNumber.nextTransNumber,
      transNoPulse: (state) => state.common.cmnTransNumber.transNoPulse,
    }),
    disableEditWkst() {
      return this.mtgSettingItem.editWkst;
    },
    editedItem: {
      get() {
        return this.item(this.baseCrudKey);
      },
      set(value) {
        this.setItem([this.baseCrudKey, value]);
      },
    },
    receivedOf() {
      const mtgWhomsList = (this.items(this.whomListCrudKey) || []).map(
        (r) => r.description || '',
      );
      mtgWhomsList.push(this.editedItem.receivedOf || '');
      return mtgWhomsList;
    },
    isNewItem() {
      return this.index(this.baseCrudKey) === -1;
    },
    isVisibleProp() {
      const isVisible = this.isVisible(this.baseCrudKey);
      if (isVisible) {
        if (this.editedItem._id) {
          this.loadFiles();
        }
        if (this.isNewItem) {
          this.determineReceiptNo();
          this.determineTransactionNo();
        }
      } else {
        this.setReceiptPolling(undefined);
        this.setTransNoPolling(undefined);
      }
      return isVisible;
    },
    transNumValue() {
      const copiedObj = JSON.parse(JSON.stringify((this.editedItem.transactionNumberObject || {})
        .paymentDetails || []));
      return copiedObj;
    },
    transactionId() {
      return this.editedItem.transactionNumberObject
      && this.editedItem.transactionNumberObject._id;
    },
    reqdSelectValidation() {
      return [
        (value) => !!value || 'Required',
      ];
    },
    termYearValidation() {
      return [
        (value) => {
          if (value && this.editedItem.dateOfMortgage) {
            // Don't validate until the year is fully typed (4 digits), else a partial
            // year like "08-01-2" zero-pads to 0002 and fires a spurious error.
            const partialYear = (value || '').toString().match(/^[0-9]{1,2}[/\\-][0-9]{1,2}[/\\-]([0-9]{1,3})$/);
            if (partialYear) {
              return true;
            }
            if (new Date(toIsoDate(value)) < new Date(this.editedItem.dateOfMortgage)) {
              return 'Mortgage Due Date must not be earlier than Date of Mortgage';
            }
          }
          return true;
        },
      ];
    },
    fiscalYearValidation() {
      return [
        (value) => !!value || 'Required',
        (value) => !Number.isNaN(parseFloat(value)) || 'Numeric required',
        (value) => parseFloat(value) > 0 || 'Must be a positive year',
        (value) => (value || '').toString().length === 4 || 'Fiscal year must be 4 digits',
        (value) => parseFloat(value) < 3000 || 'Must be a reasonable year',
      ];
    },
    fiscalYearLength() {
      return (this.editedItem.fiscalYear || '').toString().length;
    },
    voidAndBatchPaymentValidation() {
      return [
        (value) => {
          if (value && !checkStringEmptiness(this.transactionId)) {
            return 'Before making void, Delete Batch-Payments';
          }
          return true;
        },
      ];
    },
    isCorrectionMode() {
      return this.editedItem.isCorrection;
    },
    isCSCTransaction() {
      return isCscMtgTransaction(this.editedItem);
    },
  },
  methods: {
    ...mapMutations('base/crud', [
      'setItem',
    ]),
    ...mapActions('files', [
      'loadAttachedFiles',
    ]),
    ...mapActions([
      'flashInfo',
    ]),
    ...mapActions('common/cmnWhom', [
      'loadCmnWhom',
      'upsrtCmnWhom',
    ]),
    ...mapActions('mtg/mtgTransaction', [
      'loadLastReceiptNo',
      'loadLastTransactionNo',
      'updateIsVerified',
    ]),
    ...mapActions('SystemConfig', [
      'loadConfig',
    ]),
    ...mapMutations('mtg/mtgTransaction', [
      'setReceiptPolling',
      'setReceiptPulse',
      'setMortgageData',
    ]),
    ...mapMutations('common/cmnTransNumber', [
      'setTransNoPolling',
      'setTransNoPulse',
    ]),
    emitEditBatchPaymntItem() {
      this.$emit('emitEditBatchPaymntItem', this.editedItem.transactionNumberObject);
    },
    shortcutHandler(e) {
      if (isShift(e)) {
        this.ditto();
      }
    },
    ditto() {
      this.editedItem.mortgagee = this.mtgDittoStoreValues.mortgagee;
      this.editedItem.mortgagee = this.mtgDittoStoreValues.mortgagee;
      this.editedItem.receivedOf = this.mtgDittoStoreValues.receivedOf;
      this.editedItem.mortgagor = this.mtgDittoStoreValues.mortgagor;
      this.editedItem.property = this.mtgDittoStoreValues.property;
      this.editedItem.sectionLot = this.mtgDittoStoreValues.sectionLot;
      this.editedItem.township = this.mtgDittoStoreValues.township;
      this.editedItem.rangeBlk = this.mtgDittoStoreValues.rangeBlk;
      this.editedItem.dateOfMortgage = this.mtgDittoStoreValues.dateOfMortgage;
      this.editedItem.mortgageDueDate = this.mtgDittoStoreValues.mortgageDueDate;
      this.editedItem.termYear = this.mtgDittoStoreValues.termYear;
      this.editedItem.mortgageAmount = this.mtgDittoStoreValues.mortgageAmount;
      this.editedItem.remark = this.mtgDittoStoreValues.remark;
    },
    onFocusAutocomplete,
    whomUpdateSearchInput(value) {
      this.whomLastSearched = value;
    },
    whomUpdateSearchInputByNumber(number) {
      this.whomLastSearched = this.receivedOf[number];
    },
    async whomShortcutHandler(e) {
      if (e.key === 'Tab') {
        const { receivedOf } = this.editedItem;
        const { whomLastSearched } = this;
        const fields = {
          _id: '',
          description: '',
          fiscalYear: '',
        };
        const matchWhoms = this.receivedOf.filter((w) => w === receivedOf);
        const matchWhomLastSearched = this.receivedOf.filter(
          (w) => w === whomLastSearched,
        );
        if (matchWhoms.length > 0 || whomLastSearched) {
          const matchWhom = matchWhoms[0] ? matchWhoms[0] : '';
          if (
            (matchWhom || '').toLowerCase()
              !== (whomLastSearched || '').toLowerCase()
            && matchWhomLastSearched.length === 0
          ) {
            this.flashInfo('Creating a new Whom entry.');
            // create a new record to match the description typed
            const item = {
              description: whomLastSearched,
              fiscalYear: this.editedItem.fiscalYear,
            };
            await this.upsrtCmnWhom({
              item,
              fields,
              baseCrudKey: this.whomListCrudKey,
            });
            await this.loadCmnWhom({
              criteria: {},
              fields,
              baseCrudKey: this.whomListCrudKey,
            });
          }
          this.editedItem.receivedOf = whomLastSearched;
        }
        this.handlingTabOrder(e);
      }
    },
    totalRemainingPaymentAmount(value) {
      this.totalRemainingPayAmt = amountToNumber(value);
      return value;
    },
    roundAmount() {
      return amountFields.forEach((f) => {
        this.editedItem[f] = amountFormat(amountToNumber(this.editedItem[f]));
      });
    },
    amountToNum() {
      this.editedItem.amount = amountToNumber(this.editedItem.amount);
    },
    determineReceiptNo() {
      if (this.isNewItem) {
        if (this.fiscalYearLength !== 4) {
          this.setReceiptPolling(undefined);
        } else {
          const mtgTransPolling = setInterval(
            this.getRecNo,
            1200,
          );
          this.setReceiptPolling(mtgTransPolling);
        }
      }
    },
    getRecNo() {
      const { fiscalYear } = this.editedItem;
      if (!(checkStringEmptiness(fiscalYear)) && this.isNewItem) {
        this.determineNextReceiptNo(
          {
            fiscalYear,
          },
        );
      }
    },
    determineNextReceiptNo({ fiscalYear }) {
      const loadReceiptNoPromise = this.loadLastReceiptNo(
        { fiscalYear },
      );
      loadReceiptNoPromise.then(() => {
        let animate = false;
        if (this.isNewItem) {
          animate = true;
        }
        this.editedItem.receiptNumber = this.nextReceiptNumber;
        if (animate) {
          this.$nextTick(() => {
            this.setReceiptPulse(true);
          });
        } else {
          this.setReceiptPulse(false);
        }
      });
    },
    recalculateROT() {
      const { termYear, mortgageAmount, fee } = this.editedItem;
      const calcRateOfTax = mortgageCalculator.calculateRateOfTax({ termYear });
      let calcMortgageTax = mortgageCalculator.calculateMtgTax({
        mortgageAmount,
        rateOfTax: calcRateOfTax,
      });
      if (this.editedItem.isExempt) {
        calcMortgageTax = mortgageCalculator.calculateMtgTax({
          mortgageAmount: 0,
          rateOfTax: calcRateOfTax,
        });
      }
      const amount = mortgageCalculator.calculateTotalAmt({ mortgageTax: calcMortgageTax, fee });

      this.editedItem.rateOfTax = calcRateOfTax;
      if (!this.editedItem.isExempt) {
        this.editedItem.mortgageTax = calcMortgageTax;
      } else {
        this.editedItem.mortgageTax = 0;
      }
      if (!this.editedItem.isVoid) {
        this.editedItem.amount = amount;
      }
    },
    recalculateMortgageTax() {
      const { rateOfTax, mortgageAmount, fee } = this.editedItem;
      let calcMortgageTax = mortgageCalculator.calculateMtgTax({ mortgageAmount, rateOfTax });
      if (this.editedItem.isExempt) {
        calcMortgageTax = mortgageCalculator.calculateMtgTax({ mortgageAmount: 0, rateOfTax });
      }
      const amount = mortgageCalculator.calculateTotalAmt({ mortgageTax: calcMortgageTax, fee });

      this.editedItem.mortgageTax = calcMortgageTax;
      if (!this.editedItem.isVoid) {
        this.editedItem.amount = amount;
      }
    },
    checkExemptMortgagee() {
      const doesMortgageeExist = this.exemptMortgageesArrList.includes(this.editedItem.mortgagee);
      this.editedItem.isExempt = !!doesMortgageeExist;
      this.recalculateMortgageTax();
    },
    recalculateAmount() {
      const { mortgageTax, fee } = this.editedItem;
      const amount = mortgageCalculator.calculateTotalAmt({ mortgageTax, fee });

      if (!this.editedItem.isVoid) {
        this.editedItem.amount = amount;
      }
    },
    loadFiles() {
      this.loadAttachedFiles({
        bucketName: this.attachmentConstants.bucketName,
        program: this.attachmentConstants.program,
        parentObjectType: this.attachmentConstants.parentObjectType,
        parentObjectId: this.editedItem._id,
      });
    },
    isVoidChecked() {
      if (this.editedItem.isVoid) {
        this.editedItem.fee = 0;
        this.editedItem.mortgageTax = 0;
        this.editedItem.amount = 0;
        this.editedItem.paymentDetails = [];
        this.editedItem.receivedOf = '*VOID*';
        this.$emit('voidTransactionOnSave', true);
      }
    },
    isCorrectionChecked() {
      if (!this.editedItem.isCorrection) {
        return;
      }
      // A correction carries no payment details: the money was collected on an earlier
      // day, and moving it back out is done with manual GL entries.
      if (hasEnteredPaymentDetails(this.editedItem.paymentDetails)
        && !window.confirm(correctionClearsPaymentDetailsPrompt)) {
        this.editedItem.isCorrection = false;
        return;
      }
      this.editedItem.paymentDetails = [];
    },
    isVerifiedChecked() {
      this.updateIsVerified({ id: this.editedItem._id, isVerified: this.editedItem.isVerified });
    },
    toggleCscVerified() {
      this.editedItem.isVerified = !this.editedItem.isVerified;
      this.isVerifiedChecked();
    },
    calculateDateDifference() {
      if (this.editedItem.dateOfMortgage && this.editedItem.mortgageDueDate) {
        const dateOfMortgage = new Date(this.editedItem.dateOfMortgage);
        const mortgageDueDate = new Date(this.editedItem.mortgageDueDate);
        const termYear = mortgageCalculator.calculateTermYear({ dateOfMortgage, mortgageDueDate });
        if (termYear) {
          this.editedItem.termYear = termYear;
        }
      }
    },
    autofillMortgagee() {
      if (!this.mtgSettingItem.disableAutofillMortgagee) {
        if (this.editedItem.receivedOf !== '' && this.editedItem.mortgagee === '') {
          this.editedItem.mortgagee = this.editedItem.receivedOf;
        }
      } else {
        // do nothing
      }
      return this.editedItem;
    },
    mtgForteResponse(res) {
      this.editedItem.remark += res;
    },
    determineTransactionNo() {
      if (this.isNewItem) {
        if (this.fiscalYearLength !== 4) {
          this.setTransNoPolling(undefined);
        } else {
          const transNoPolling = setInterval(
            this.getTransNo,
            1200,
          );
          this.setTransNoPolling(transNoPolling);
        }
      }
    },
    getTransNo() {
      const { fiscalYear } = this.editedItem;
      if (!(checkStringEmptiness(fiscalYear)) && this.isNewItem) {
        this.determineNextTransNo(
          {
            fiscalYear,
          },
        );
      }
    },
    determineNextTransNo({ fiscalYear }) {
      const loadTransNoPromise = this.loadLastTransactionNo(
        { fiscalYear },
      );
      loadTransNoPromise.then(() => {
        const animate = true;
        this.editedItem.transactionNumber = this.nextTransNumber;
        if (animate) {
          this.$nextTick(() => {
            this.setTransNoPulse(true);
          });
        } else {
          this.setTransNoPulse(false);
        }
      });
    },
    handlingTabOrder(e) {
      if (this.editedItem && this.editedItem.receivedOf) {
        e.preventDefault();
        document.getElementById('mtgTransItemMortgagorText').focus();
        this.autofillMortgagee();
      }
    },
    businessDateValidation(value) {
      const fy = this.editedItem.fiscalYear;
      const fyStart = new Date(`${fy - 1}-07-01`);
      const fyEnd = new Date(`${fy}-07-07`);
      const businessDate = new Date(toIsoDate(value));
      return (
        (businessDate >= fyStart && businessDate <= fyEnd)
        || 'Business Date must fall within the fiscal year'
      );
    },
  },
};
</script>

<style scoped>
.v-container ::v-deep .row {
  margin-top: 0;
  margin-bottom: 0;
}
.v-container ::v-deep .col,
.v-container ::v-deep [class*='col-'] {
  padding-top: 4px;
  padding-bottom: 4px;
}
.v-container ::v-deep .v-label,
.v-container ::v-deep .v-text-field__slot input,
.v-container ::v-deep .v-text-field__slot textarea,
.v-container ::v-deep .v-messages,
.v-container ::v-deep .v-input--selection-controls__input + label {
  font-size: 0.8125rem;
}
</style>
